import React, { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { getNewChartData, getDatasourceAndDates } from '../../../api';
import $ from "jquery";
import { isFullscreen } from '../utils/Utils';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

const IMG_URL = process.env.IMG_FULL_URL;

const responsiveRes = 870;
const mobileRes = 500;
class WorkRelatedDiseasesChart extends Component {
    constructor(props){
        super(props);

        let width = undefined;

        let isGlobalOrEU = false;
        if (props.country.code == 'EU27_2020' || this.props.country.code == 'GLOBAL' || props.fullCountryReport == true)
        {
            isGlobalOrEU = true;
        }

        if(window.innerWidth < mobileRes){
            width = 350;
        }else{
            width = props.width;
        }

        this.state = {
            chartConfig: {
                title: {
                    text: this.props.country ? this.props.country.name : '',
                    align: 'center',
                    style: {
                        color: '#666',
                        font: "18px OpenSans",
                        fontWeight: 'bold'
                    }
                },
                credits: {
                    enabled: true,
                    text: "",
                    href: '',
                    style: {
                        cursor: 'arrow'
                    },
                    position: {
                        x: -130
                    }
                },
                colors: ['#f6a400','#cbe2e3','#57575a','#ffe300','#449fa2','#f3c564','#4f8e3a', '#e5c6d7'],
                chart: {
                    width: width,
                    //height: height,
                    marginTop: isGlobalOrEU,
                    //borderWidth: 1,
                    type: 'pie',
                    backgroundColor: isGlobalOrEU,
                    events: {
                        render: function() {
                            let chart = this;
                            if (!chart.customImage)
                            {
                                chart.customImage = chart.renderer.image(
                                   `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                                   chart.chartWidth - 130,
                                   chart.chartHeight - 37,
                                   130,
                                   37
                                ).add();
                                chart.customImage.attr({
                                   class:'osha-logo'
                                });
                            }
                            else
                            {
                                chart.customImage.attr({
                                    x: chart.chartWidth - 130,
                                    y: chart.chartHeight - 37
                                });
                            }
    
                            if (chart.fullscreen.isOpen) {
                                chart.customImage.css({
                                   display: 'block'
                                });
                                chart.container.className = 'highcharts-container full-screen';
                            }
                            else
                            {
                                chart.legend.options.x=0;
                                chart.customImage.css({
                                    display: ''
                                });	
                                chart.container.className = 'highcharts-container';
                            }
                        },
                    },
                },
                exporting: {
                    enabled: this.props.fullCountryReport == true ? false: true,
                    buttons: {
                        contextButton: {
                            menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
                        }
                    },
                    chartOptions: {
                        chart: {
                          backgroundColor: '#ffffff'
                        },
                        legend: {
                            layout: 'vertical',
                            align: 'right',
                            verticalAlign : 'middle',
                            x : 0
                        }
                      },
                      sourceWidth: 900,
                      sourceHeight: 500,
                      scale: 1 
                },
                navigation: {
                    buttonOptions: {
                        align: 'left',
                        theme: {
                            fill: 'transparent',
                            states: {
                                hover: {
                                    fill: '#CCC'
                                },
                                select: {
                                    fill: 'transparent'
                                }
                            }
                        }
                    }
                },
                legend: {
                    enabled: true,
                    floating: isGlobalOrEU ? false : true,
                    align: window.innerWidth > responsiveRes && isGlobalOrEU ? 'right' : 'center',
                    verticalAlign: window.innerWidth > responsiveRes && isGlobalOrEU ? 'middle' : 'bottom',
                    //width: '35%',
                    //borderWidth: 1,
                    itemWidth: 150,
                    title: {
                        text: this.props.legendTitle != null ? this.props.legendTitle : "",
                        style: {
                            font: "14px OpenSans",
                            fontWeight: 'normal',
                            color: "grey"
                        }
                    },
                    squareSymbol: true,
                    symbolRadius: 0,
                    itemStyle: {
                        //width: 200,
                        // color: '#000000',
                        font: "14px OpenSans",
                        fontWeight: 'normal',
                        textOverflow: null
                    },
                    itemDistance: 15
                    
                }, 
                tooltip: {
                    // headerFormat: '<b>{point.x}</b><br/><b>{series.name}</b><br/>',
                    // pointFormat: '<b>{point.y}%</b> ',
                    enabled:true,
                    useHTML: true,
                    opacity:0.9,
                    backgroundColor: '#333333',
                    borderColor: '#000000',
                    zIndex: 100,
                    style: {
                        width: 450,
                        color: 'white',
                        fontFamily: 'OpenSans',
                        fontWeight: 'normal',                    
                        fontSize:'12px'
                    },
                    formatter: function () {
                        return '<ul class="tooltip-item">'+
                        '<li><strong class="tooltip-value">Illness: </strong>'+ this.point.name  +' </li>' +
                        '<li><strong class="tooltip-value">Percent: </strong> '+ Math.round(this.percentage*Math.pow(10,2))/Math.pow(10,2) +'%</li>' +
                        '<li><strong class="tooltip-value">Value per 100.000: </strong> '+ Math.round(this.y*Math.pow(10,2))/Math.pow(10,2) +'</li>' +
                        '</ul>';
                    }
                },
                plotOptions: {
                    series: {
                        states: {
                            hover: {
                                brightness: 0,
                                halo: {
                                    size: 0,
                                    attributes: {
                                        'stroke-width': 0 //to keep default setting
                                    }
                                }
                            }
                        }
                    },
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        size: window.innerWidth > 600 ? '80%' : '60%',
                        slicedOffset: 0,
                        dataLabels: {
                            distance: '-30%',
                            enabled: true, 
                            style: {
                                font: "14px OpenSans",
                                fontSize: "14px"
                            },
                            alignTo: window.innerWidth > 600 ? undefined : "toPlotEdges",
                            allowOverlap: false,
                            format: '{point.percentage:.1f} %',
                            filter: {
                                property: 'percentage',
                                operator: '>',
                                value: 5
                            }
                        },
                        showInLegend: {
                            enabled:true
                        }
                    }
                }
            },
            isLoading: false,
            illnesses: [],
            isGlobalOrEU: isGlobalOrEU
        }
    }

    getLoadData = (chartType) => {
        let chart = [];
        let series = [];

        if(chartType){
            if(this.props.diseasesSource){
                chart = chartType.find((chart) => chart.type == this.props.diseasesSource.value);
            }else{
                chart = chartType[0];
            }
        }

        let chartTitle = this.state.chartConfig.title.text;
        if (this.props.country != undefined && this.props.country.name != chartTitle)
        {
            chartTitle = this.props.country.name;
        }

        if (this.props.legendTitle != null && this.props.legendTitle != this.state.chartConfig.legend.title.text)
        {
            this.setState({ chartConfig: {...this.state.chartConfig, title: {...this.state.chartConfig.title, text: chartTitle },  legend: { ...this.state.chartConfig.legend, title: {...this.state.chartConfig.legend.title, text: this.props.legendTitle } } } })
        }
        else if (chartTitle != this.state.chartConfig.title.text)
        {
            this.setState({ chartConfig: {...this.state.chartConfig, title: {...this.state.chartConfig.title, text: chartTitle } } } );
        }

        this.getCredits(chart.chart);

        let requestFilter = {
            chart: chart.chart,
            indicator: chart.chartIndicator,
            country1: this.props.country.code,
            illness: chart.illness
        }
        getNewChartData(requestFilter)
        .then((data) => {
            if(data.resultset != undefined){

                if (data.resultset.data.length > 0)
                {
                    data.resultset.data.forEach(element => {
                        series.push({name: element.name, y: element.data[0]});
                    });
    
                    this.setState({
                        chartConfig: {...this.state.chartConfig, 
                            series: [{
                                name: "Values",
                                colorByPoint: true,
                                data: series
                            }]
                        },
                        illnesses: series
                    })
                }
                else
                {
                    this.setState({
                        chartConfig: {...this.state.chartConfig, 
                            series: [{
                                name: "Values",
                                colorByPoint: true,
                                data: []
                            }]
                        },
                        illnesses: []
                    })
                }
            }
        })
    }

    getCredits = (chart) => {
        getDatasourceAndDates(chart).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })		
    }

    componentDidMount() {
        this.getLoadData(this.props.chartType);
    }
    
    componentDidUpdate(prevProps) {
        if(prevProps.diseasesSource != this.props.diseasesSource){
            this.getLoadData(this.props.chartType);
        }

        window.addEventListener('resize', this.updateDimension);
        window.addEventListener('scroll', this.updateDimensionScroll);
    }

    //con resoluciones pequeñas menos de 800, cambiar el if de lado
    updateDimension = () => {
        const width = window.innerWidth;

        if (isFullscreen())
        {
            this.setState({
                chartConfig: { ...this.state.chartConfig,
                    chart: { ...this.state.chartConfig.chart,
                        width: width - 50
                    },
                    legend: { ...this.state.chartConfig.legend,
                        align: width < responsiveRes ? 'center' : 'right',
                        verticalAlign: width < responsiveRes ? 'bottom' : 'middle',
                        layout: width < responsiveRes ? 'horizontal' : 'vertical',
                        y: width < responsiveRes ? -20 : undefined,
                        itemMarginBottom: width < responsiveRes ? 0 : 2.5
                    }
                }
            })
        }
        else
        {
            if(width < responsiveRes){
                $('.section--sticky--chart').removeClass('chart-position-fixed');
                $('.pie--chart--section').removeClass('next-to-position-fixed');
                $('.work-related-diseases').removeClass('no-margin');
                if(this.state.isGlobalOrEU){
                    this.setState({
                        chartConfig: {...this.state.chartConfig, 
                            chart: { ...this.state.chartConfig.chart,
                                width: width < mobileRes ? 350 : this.props.width,
                                marginTop: 20,
                            },
                            legend: { ...this.state.chartConfig.legend,
                                align: 'center',
                                verticalAlign: 'bottom',
                                itemWidth: 150,
                                itemStyle: { ...this.state.chartConfig.legend.itemStyle,
                                    textOverflow: null
                                },
                                itemMarginBottom: 0
                            }
                        }
                    })
                }
                else
                {
                    // Set width as default in case previous state was in full screen
                    this.setState({
                        chartConfig: { ...this.state.chartConfig,
                            chart: { ...this.state.chartConfig.chart,
                                width: width < mobileRes ? 350 : this.props.width,
                            },
                            legend: { ...this.state.chartConfig.legend,
                                align: 'center',
                                verticalAlign: 'bottom',
                                layout: 'horizontal',
                                itemMarginBottom: 0
                            }
                        }
                    })
                }
            }else{
                if(this.state.isGlobalOrEU){
                    this.setState({
                        chartConfig: {...this.state.chartConfig,
                            chart: { ...this.state.chartConfig.chart,
                                width: width < mobileRes ? 350 : this.props.width,
                            },
                            legend: { ...this.state.chartConfig.legend,
                                align: 'right',
                                verticalAlign: 'middle',
                                itemStyle: { ...this.state.chartConfig.legend.itemStyle,
                                    textOverflow: null
                                },
                                itemMarginBottom: 0
                            }
                        }
                    })
                }
                else
                {
                    // Set width as default in case previous state was in full screen
                    this.setState({
                        chartConfig: { ...this.state.chartConfig,
                            chart: { ...this.state.chartConfig.chart,
                                width: width < mobileRes ? 350 : this.props.width,
                            },
                            legend: { ...this.state.chartConfig.legend,
                                align: 'center',
                                verticalAlign: 'bottom',
                                layout: 'horizontal',
                                itemMarginBottom: 0
                            }
                        }
                    })
                }
            }
        }
    }

    updateDimensionScroll = () => {
        const width = window.innerWidth;

        if(width > responsiveRes)
        {
            if (window.innerHeight>730 && (document.body.scrollTop > 520 || document.documentElement.scrollTop > 520)) 
            {
                let methodologyHeight = ($('.section--methodology').offset().top-$(window). height() );
                if ($(window).scrollTop()>= methodologyHeight){
                    $('.section--sticky--chart').addClass('chart-position-fixed-scroll');
                }else{
                    $('.section--sticky--chart').removeClass('chart-position-fixed-scroll');
                    $('.section--sticky--chart').addClass('chart-position-fixed');
                    $('.pie--chart--section').addClass('next-to-position-fixed');
                    $('.work-related-diseases').addClass('no-margin');
                }
                if(this.state.isGlobalOrEU){
                    this.setState({
                        chartConfig: {...this.state.chartConfig, 
                            chart: { ...this.state.chartConfig.chart,
                                //height: 370,
                                marginTop: -20,
                            },
                            legend: { ...this.state.chartConfig.legend,
                                align: 'right',
                                verticalAlign: 'middle',
                                itemStyle: { ...this.state.chartConfig.legend.itemStyle,
                                    textOverflow: null
                                }
                            }
                        }
                    })
                }
            } 
            else 
            {
                $('.section--sticky--chart').removeClass('chart-position-fixed');
                $('.pie--chart--section').removeClass('next-to-position-fixed');
                $('.work-related-diseases').removeClass('no-margin');
                if(this.state.isGlobalOrEU){
                    this.setState({
                        chartConfig: {...this.state.chartConfig, 
                            chart: { ...this.state.chartConfig.chart,
                                marginTop: 0
                            },
                            legend: { ...this.state.chartConfig.legend,
                                itemStyle: { ...this.state.chartConfig.legend.itemStyle,
                                    textOverflow: null
                                }
                            }
                        }
                    })
                }
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimension);
        window.removeEventListener('scroll', this.updateDimensionScroll);
    }

    render() {
        let customLegend;

        if(!this.props.legend){
            customLegend = (
                <div id="legend">
                    {
                        this.state.illnesses.map((illness, index) => {
                            return (
                                <a href="#" id={`illness-${index}`} key={illness.name}>
                                    {Math.round(illness.y)}</a>
                            )
                        })
                    }
                </div>
            );
        }

        if (this.state.illnesses.length > 0)
        {
            return(
                <React.Fragment>
                    <div className='chart-container'>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.state.chartConfig}
                            containerProps={{ className: 'chartContainer' }}
                        />
                    </div>
                    {customLegend}
                </React.Fragment>
            )
        }
        else
        {
            return null;
        }
    }
}

export default WorkRelatedDiseasesChart;